import { render, staticRenderFns } from "./references.vue?vue&type=template&id=01a36f54&scoped=true"
import script from "./references.vue?vue&type=script&lang=js"
export * from "./references.vue?vue&type=script&lang=js"
import style0 from "./references.vue?vue&type=style&index=0&id=01a36f54&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01a36f54",
  null
  
)

export default component.exports